import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const NeedPasswordWrapper = styled.div`
  margin-top: 10px;
`;

export const ErrorContainer = styled.div`
  text-align: right;
  color: ${({ theme }) => theme.brandRed.a10};
  padding: 0 13px 17px 0;
`;

export const NeedPasswordLink = styled(Link)`
  display: block;
  padding: 0 1rem;
  color: ${({ theme }) => theme.white.a10};
  font-size: 13px;
  line-height: 24px;
  letter-spacing: 0.3px;
  text-align: left;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.white.a10};
  }
`;

export const StyledLoginForm = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
`;
